import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppState } from '../../state';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { isAuthReady, user } = useAppState();
  const location = useLocation();

  const renderChildren = user || false;

  if (!renderChildren && !isAuthReady) {
    return null;
  }

  if (!renderChildren) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
